import ImageSetImageDisplay from "./ImageSetImageDisplay";
import { useSelector, useDispatch } from 'react-redux';
import G from './Getters';
import imageMap from './imageMap';
import { useState, useEffect } from 'react';
import A from './ActionCreators';
import { ALL_UNITS } from './Units';

let fallBackOnRaw = false;
if( process.env.NODE_ENV !== "production" ){
  fallBackOnRaw = true;
}

const largerUnits = new Set(["km","hm","dam","m","dm"]);

const UNIT_MAP = {
  "ppum":"pixels / μm"
}

const justReturn = val => val;
const invert = val => 1/val;



let UNIT_TO_PROCESSOR = {};
const UNIT_OPTIONS = [];
const resUnits = [];
const smallerUnits = ALL_UNITS.filter(x => !largerUnits.has(x));

const resUnitToUnit  = { }

smallerUnits.forEach(unit => {
  let resUnit = `pixels / ${unit}`;
  resUnits.push(resUnit);
  resUnitToUnit[resUnit] = unit;
  UNIT_TO_PROCESSOR[resUnit] = justReturn;
  UNIT_OPTIONS.push(<option value={resUnit}>{resUnit}</option>);
})

smallerUnits.forEach(unit => {
  let resUnit  = `${unit} / pixel`;
  resUnitToUnit[resUnit] = unit;
  resUnits.push(resUnit);
  UNIT_TO_PROCESSOR[resUnit] = invert;
  UNIT_OPTIONS.push(<option value={resUnit}>{resUnit}</option>);
})



export default function ImageResolutionSpecificationModal({
  imageSetId, 
  onClose, 
  mode, 
  onEvent ,
  resolution
}){

  let dispatch = useDispatch();

  const [ isotropic, setIsotropic ] = useState(true);
  const [ xRes, setXRes ] = useState(resolution?.isotropic||0);
  const [ yRes, setYRes ] = useState();
  const [ units, setUnits ] = useState(resUnits[2]);

  //let { url, version } = output;

  let iso = isotropic;

  let submitDisabled = !(
    (!iso || (xRes))
    &&
    (iso || (xRes && yRes))
  )

  //Boolean(Number(xRes)) && (isotropic || Boolean(Number(yRes)));


  

  let body = (
    <div class="fair-padding">
      <h1 class="">Set Image Resolution</h1>

      <ImageSetImageDisplay imageSetId={imageSetId}/>
      {/*false && <>
      <img src={imageMap[url]||url} style={{width:'50%'}}/>
      <div>{url}</div>
      </>*/}

      <div class="sg-row">
        <div>
      <div>Image Resolution</div>
      <div><input input={"image-resolution-x"} 
          onChange={e => {
            setXRes(Number(e.target.value))
          }} 
          type="number" value={xRes} min={0}/>
      </div>
        </div>
        <div>
          <div>Units</div>
          <select onChange={e => setUnits(e.target.value)} value={units}>
            {UNIT_OPTIONS}
          </select>
        </div>
      </div>

      {!isotropic && (
        <div><input input={"image-resolution-y"} onChange={e => setYRes(e.target.value)} type="number" value={yRes} min={0}/></div>
      )}


      <button option={"accept"} onClick={() => {


        let resolution = {units:resUnitToUnit[units]}
        if( isotropic ){
          resolution.isotropic = xRes;
        }else{
          resolution.x = xRes;
          resolution.y = yRes;
        }

        dispatch(A.setImageSetProperties({
          _id:imageSetId,
          properties:{ resolution }
        }))

        onClose();
      }} disabled={submitDisabled} class="btn btn-success">Okay</button>

    {false && <div>Need to set different resolutions for width and height? Contact support.</div>}

    </div>
  )

  return body;


}
